/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useRef, useState } from "react";
import fetchHelper from "../../services/fetchHelper";
import cn from "classnames";

export const Priority = ({ userInfo }) => {
  const [value, setValue] = useState(userInfo.priorityFlag || "");
  const [oldValue, setOldValue] = useState(userInfo.priorityFlag || "");
  const [isLoading, setIsLoading] = useState("");
  const [isSuccess, setIsSuccess] = useState(null);
  const [successStatus, setSuccessStatus] = useState(null);
  const timeo = useRef(null);

  const updateStatus = (type, status) => {
    setIsSuccess(type);
    setSuccessStatus(status);
    if (timeo.current) clearTimeout(timeo.current);
    timeo.current = setTimeout(() => {
      setIsSuccess(null);
      setSuccessStatus(null);
    }, 3000);
  };

  const updatePriority = async (value) => {
    if (isLoading) return false;
    setSuccessStatus(null);
    setIsSuccess(null);
    setIsLoading(value);
    try {
      setValue(value);
      const url = "/patientmanagement/rest/interrogations/" + userInfo.id + "/updatePriorityFlag";
      const response = await fetch(url, {
        method: "PUT",
        headers: fetchHelper.getSecurityHeader(),
        body: JSON.stringify({
          priorityFlag: value,
          id: userInfo.id,
        }),
      });
      if (!isLoading) {
        if (response.ok) {
          updateStatus(value, true);
          setOldValue(value);
        } else {
          updateStatus(value, false);
          setValue(oldValue);
        }
        setIsLoading("");
      }
      return response;
    } catch (err) {
      updateStatus(value, false);
      setIsLoading("");
      setValue(oldValue);
    }
    setIsLoading("");
  };

  const getClass = (type) => {
    if (isLoading === type) {
      return "circle loading";
    } else {
      if (isSuccess === type) {
        return "circle " + (successStatus ? "success" : "error");
      } else {
        return value === type ? "active" : undefined;
      }
    }
  };

  return (
    <label className="high-priority-v2">
      <ul
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          height: "100%",
        }}
      >
        <li className="info-text" style={{ paddingRight: 15 }}>
          Priority
        </li>
        <li
          className={cn("prio-green", getClass("GREEN"))}
          onClick={(e) => {
            e.preventDefault();
            updatePriority("OFF");
          }}
        ></li>
        <li
          className={cn("prio-orange", getClass("YELLOW"))}
          onClick={(e) => {
            e.preventDefault();
            updatePriority("YELLOW");
          }}
        ></li>
        <li
          className={cn("prio-red", getClass("RED"))}
          onClick={(e) => {
            e.preventDefault();
            updatePriority("RED");
          }}
        ></li>
      </ul>
    </label>
  );
};
